import ServiceConfigPrices from 'components/services/ServiceConfigPrices'

const TestPage = () => {
    return (
        <div>
            <ServiceConfigPrices serviceId={1} />
        </div>
    )
}

export default TestPage
